/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignChannelUpdate } from '../../axios/campaignChannelUpdate'
import type {
	CampaignChannelUpdateError,
	CampaignChannelUpdatePathParams,
	CampaignChannelUpdateResponse,
} from '../../types/CampaignChannelUpdate'

export const campaignChannelUpdateMutationKey = () => [{ url: '/campaigns/:campaign/channels/:channel' }] as const

export type CampaignChannelUpdateMutationKey = ReturnType<typeof campaignChannelUpdateMutationKey>

export type CampaignChannelUpdateVariables = {
	campaign: CampaignChannelUpdatePathParams['campaign']
	channel: CampaignChannelUpdatePathParams['channel']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignChannelController.php CampaignChannelController::update */
export function useCampaignChannelUpdate<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignChannelUpdateResponse,
		AxiosError<CampaignChannelUpdateError>,
		CampaignChannelUpdateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignChannelUpdateMutationKey(),
		mutationFn: ({ campaign, channel }: CampaignChannelUpdateVariables) =>
			campaignChannelUpdate(campaign, channel, config).then(res => res.data),
		...options,
	})
}
